
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05f1a0b70078e78a': `Je souhaite un programme avant ou après le circuit`,
's089c4407b545986a': `dès`,
's11cba9ac69a050ec': `Indiquez-nous la période souhaitée pour votre voyage ou les alternatives possibles`,
's14b76ac03be4da81': `Vos coordonnées`,
's1dfd8aad3ccd9347': `Nombre de personnes`,
's2618ab80606e96d3': `Les prix indicatifs s'entendent par personne adulte en chambre double. En cas de nombre impair de personnes, le prix total peut varier.`,
's2905f7b58be224ef': `Votre équipe KUONI`,
's2b65fcba4f882ed8': `Vous recevrez une réponse de notre part dans les 48 heures.`,
's3026a7ba9aefb549': `Envoyer la demande`,
's34dc17d860d2efba': `Monsieur`,
's476f5d3d5143d4d8': `Civilité`,
's4794acf374b0320f': `Âge de l'enfant`,
's4bfb1b187d6b7309': `Nous traitons vos données conformément à notre`,
's4e9995a5ac28f038': `Nom`,
's55d6064b5307f215': `Je souhaite recevoir également une offre de vol`,
's5b7ca741f9246d12': `Merci beaucoup !`,
's5f8f4fddf2eca090': `Je souhaite recevoir la newsletter personnalisée.`,
's6064a8ed3411278c': `Participants au voyage`,
's63e457bc703a3030': `E-mail`,
's66a8ea9d4609abf8': `Déclaration de protection des données`,
's6775d2d0f1d5b365': `Veuillez saisir un numéro de téléphone valide.`,
's6bec47f8e7d7f845': `Veuillez choisir`,
's722205a7f93b510b': `Une erreur s'est malheureusement produite. Veuillez réessayer plus tard.`,
's78a62d35a630c984': `Non binaire`,
's78bb5da2bfa9e69d': `(à partir de 13 ans)`,
's82badbeb3be9c782': `Prix par personne`,
's8574d5c3c3731cef': `Vous avez des questions ? Contactez nos experts au`,
's85f2b6f2f08fe262': `Choisissez votre agence de voyages`,
's90de8980c73e442b': `Nous avons bien reçu votre demande.`,
's9145cec5896965b7': `(jusqu'à 12 ans)`,
's942feefaf37ce8d4': `Retour à l'offre`,
'sa026193d0982c3c4': `Nombre d'enfants`,
'sa67c3584d609b83f': `Madame`,
'sab1114a5f102dedc': `Téléphone`,
'saf63a04c86018698': `-`,
'sb2d649e7dd0e0cf4': `eMail Confirmation`,
'sb3ec52a339a36d4a': `Je souhaite des suggestions d'excursions`,
'sb44d8e5feaffc4df': `Dans le cas où aucune réservation n'aboutirait, j'accepte des frais de conseil de CHF 150.– (entièrement déductibles en cas de réservation).*`,
'sb68e190d580d59e0': `Nous indiquons de manière transparente dans l'offre les coûts supplémentaires liés aux adaptations ou aux prestations complémentaires.`,
'sca5449aa9009dadf': `Prestations supplémentaires optionnelles`,
'sd72cac450c159603': `Prénom`,
'se9cd616a129d76e4': `Période de voyage`,
'seefcaf121c27243d': `Message`,
'sf9c72fd7f187b4a2': `https://www.kuoni.ch/fr/protection-des-donnees`,
    };
  